import { Box, CircularProgress, Grid, MenuItem } from '@material-ui/core';
import InputField from 'components/InputField';
import SelectInputField from 'components/SelectInputField';
import { QuestionSecret } from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot';
import messages from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot/messages';
import {
  StyledOrangeButton,
  StyledPrimaryButton,
} from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot/styles';
import validationSchema from 'containers/PasswordRecoveryPages/QuestionScrtMethodForgot/validationSchema';
import { FormikProps, withFormik } from 'formik';
import { EVENT_CATEGORIES } from 'helpers/GATracking';
import GaClickHOC from 'helpers/GATracking/GaClickHOC';
import { translate } from 'helpers/intl';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

const InsertQuestionScrtForm = (props: FormProps & FormikProps<FormValues>) => {
  const {
    values,
    errors,
    handleSubmit,
    handleChange,
    handleBlur,
    proceedDifferently,
    isLoading,
  } = props;

  return (
    <form onSubmit={handleSubmit}>
      <Box paddingY={2} paddingX={[2, 4, 8]}>
        <Grid container justify="space-between" direction="column">
          <Grid item xs>
            <SelectInputField
              name="questionSecret"
              label={translate({ ...messages.questionField }, props)}
              onChange={handleChange}
              value={values.questionSecret}
              data={props.questionSecret}
              handleBlur={handleBlur}
              Children={[...props.questionSecret].map((item: any) => (
                <MenuItem value={item.value} key={item.label}>
                  {item.label}
                </MenuItem>
              ))}
            />
          </Grid>
          <Box marginBottom={2}></Box>
          <Grid item xs>
            <InputField
              name="response"
              placeholder={translate({ ...messages.responseField }, props)}
              value={values.response}
              error={
                props.errorMessage
                  ? translate({ ...messages.responseError }, props)
                  : errors.response
              }
              helperText={
                props.errorMessage
                  ? translate({ ...messages.responseError }, props)
                  : errors.response
              }
              handleChange={handleChange}
              handleBlur={handleBlur}
            />
          </Grid>

          <Grid item xs>
            <GaClickHOC
              category={EVENT_CATEGORIES.FORGOTTEN_PASSWORD_QUESION_SECRETE}
              label="valider"
            >
              <StyledOrangeButton type="submit" variant="contained">
                {isLoading ? (
                  <CircularProgress data-testid="loader" size={20} />
                ) : (
                  <React.Fragment>
                    {translate({ ...messages.valid }, props)}
                  </React.Fragment>
                )}
              </StyledOrangeButton>
            </GaClickHOC>
          </Grid>

          <Grid item xs>
            <GaClickHOC
              category={EVENT_CATEGORIES.FORGOTTEN_PASSWORD_QUESION_SECRETE}
              label="Procéder autrement"
            >
              <StyledPrimaryButton
                variant="outlined"
                onClick={proceedDifferently}
              >
                {translate(messages.proceedDifferently, props)}{' '}
              </StyledPrimaryButton>
            </GaClickHOC>
          </Grid>
        </Grid>
      </Box>
    </form>
  );
};

export interface FormProps {
  intl: IntlShape;
  isLoading: Boolean;
  onSubmitStep: Function;
  proceedDifferently: Function;
  questionSecret: QuestionSecret[];
  errorMessage?: string;
}

interface FormValues {
  questionSecret: string;
  response: string;
}

const Form = withFormik<FormProps, FormValues>({
  mapPropsToValues: () => {
    return {
      questionSecret: '1',
      response: '',
    };
  },

  validationSchema,

  handleSubmit: ({ response, questionSecret }, { props }) => {
    props.onSubmitStep({
      questionSecret: questionSecret,
      response: response,
    });
  },
})(InsertQuestionScrtForm);

export default injectIntl(Form);
